import React from 'react';
import { componentService } from 'js/services/component.service';

export const LoggedIn = React.lazy(() => import(/* webpackChunkName: "logged-in" */ './LoggedIn'));

componentService.registerWebContentComponents({ LoggedIn });
